import React from 'react';
import Accordion from './Accordion';
const $ = window.$;

class AccordionFrame extends React.Component {


    static openall(e) {
        e.preventDefault();
        $('.panel-collapse:not(".show")').collapse('show');
    }


    static closeall(e) {
        e.preventDefault();
        $('.panel-collapse.show').collapse('hide');
    }


    renderCollapseExpand() {
        var size = 0;
        if (this.props.list !== undefined && this.props.list.length !== 0) {
            size = this.props.list.length;
        }
        if (size > 1) {
            return (
                <div className="row">
                    <div className="d-none d-md-block col-md-12 collapse-expand">
                        <button onClick={AccordionFrame.openall} className="button-collapse"><i className='fas fa-chevron-down circle-icon-down'></i>&Aring;pne alt</button>
                        <button onClick={AccordionFrame.closeall} className="button-collapse"><i className='fas fa-chevron-right circle-icon-right'></i>Lukk alt</button>
                    </div>
                    <div className="d-md-none col-md-12 collapse-expand-none"></div>
                </div>
            )
        }
        else return null;
    }



    render() {

        if (this.props.list !== undefined) {
            return (
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div id="accordion">
                                {this.renderCollapseExpand()}
                                <Accordion list={this.props.list} summary={this.props.summary}/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
  }
}

export default AccordionFrame;

